import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useCustomerAuth } from "@/context/CustomerAuthContext";
import { Reveal } from "@/components/Reveal";
import { toast } from "sonner";

export default function ResetPassword() {
  const { setNewPassword, customer } = useCustomerAuth();
  const navigate = useNavigate();
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (password.length < 8) return setError("Password must be at least 8 characters.");
    if (!customer) return setError("This reset link has expired. Please request a new one.");
    if (password !== confirm) return setError("Passwords do not match.");
    setError("");
    setLoading(true);
    try {
      await setNewPassword(password);
      toast.success("Password updated - you're signed in.");
      navigate("/account");
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="max-w-md mx-auto px-5 py-16 min-h-[70vh]" data-testid="reset-password-page">
      <Reveal className="text-center mb-8">
        <p className="text-xs uppercase tracking-[0.28em] text-pink">Account</p>
        <h1 className="font-serif text-4xl mt-3 text-charcoal">New Password</h1>
        <div className="w-16 h-px bg-gold mx-auto mt-5" />
      </Reveal>

      {!token ? (
        <p className="text-center text-gray-500">Invalid reset link. <Link to="/forgot-password" className="text-pink hover:underline">Request a new one</Link>.</p>
      ) : (
        <form onSubmit={submit} className="space-y-4">
          <input type="password" required value={password} onChange={(e) => setPassword(e.target.value)}
            placeholder="New password" data-testid="reset-password"
            className="w-full border border-gray-200 px-4 py-3 text-sm focus:outline-none focus:border-pink" />
          <input type="password" required value={confirm} onChange={(e) => setConfirm(e.target.value)}
            placeholder="Confirm password" data-testid="reset-confirm"
            className="w-full border border-gray-200 px-4 py-3 text-sm focus:outline-none focus:border-pink" />
          {error && <p className="text-sm text-pink">{error}</p>}
          <button type="submit" disabled={loading} data-testid="reset-submit"
            className="w-full bg-pink text-white py-3.5 text-xs uppercase tracking-[0.18em] hover:bg-pink-hover transition-colors disabled:opacity-60">
            {loading ? "Updating..." : "Update Password"}
          </button>
        </form>
      )}
    </div>
  );
}
